/** Simulated clock. The shift starts at 06:00, which is when the day shift takes over. */
export const SHIFT_START_HOUR = 6;

export function fmtSimTime(simSeconds: number): string {
  const total = Math.max(0, simSeconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = Math.floor(total % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function fmtClock(simSeconds: number): string {
  const t = SHIFT_START_HOUR * 3600 + Math.max(0, simSeconds);
  const h = Math.floor(t / 3600) % 24;
  const m = Math.floor((t % 3600) / 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function fmtDuration(seconds: number): string {
  if (seconds < 60) return `${seconds.toFixed(0)} s`;
  if (seconds < 3600) return `${(seconds / 60).toFixed(1)} min`;
  return `${(seconds / 3600).toFixed(2)} h`;
}

export function fmtNumber(v: number, decimals = 2): string {
  if (!Number.isFinite(v)) return '——';
  return v.toFixed(decimals);
}
